import { CUSTOMER_EMAIL_CAPTURED_EVENT_NAME } from '../../events/customer-email-captured-event';
import AppStorage from '../../utils/storage';
import { GTM_CUSTOMER_EMAIL_STORAGE_KEY } from '../constants';

document.addEventListener(CUSTOMER_EMAIL_CAPTURED_EVENT_NAME, (event) => {
    const capturedEmail = event.email;
    if (capturedEmail === '') {
        return;
    }
    const customerEmailOnLocalStorage = AppStorage.getItem(GTM_CUSTOMER_EMAIL_STORAGE_KEY);
    if (typeof customerEmailOnLocalStorage !== 'string' || customerEmailOnLocalStorage !== capturedEmail) {
        console.log(`--- Customer E-Mail captured! ${capturedEmail} ---`);
        AppStorage.setItem(GTM_CUSTOMER_EMAIL_STORAGE_KEY, capturedEmail);
    }
});
